import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
	changeDetection: ChangeDetectionStrategy.OnPush,
	selector: 'bp-icon-hall-monitor',
	templateUrl: './icon-hall-monitor.component.svg',
})
export class IconHallMonitorComponent {}
